import * as PIXI from "pixi.js";
import TextureManager from "../managers/TextureManager";
import BoxLayer from "../layers/BoxLayer";
import { winningIcons } from "../types/Config";


export default class WinningIcon extends PIXI.Sprite {
  private BoxLayer = BoxLayer.getInstance();
  constructor(wIconIndex: number, x: number, y: number) {
    super()
    this.x = x;
    this.y = y;
    this.width = wIconIndex == 0 ? 100 : 125;
    this.height = wIconIndex == 0 ? 100 : 125;
    this.anchor.set(.5);
    this.BoxLayer.addChild(this);
    this.addTexture(wIconIndex)
  }
  setTail(a:boolean){}
  addTexture(wIconIndex) {
    const iconPath = winningIcons[wIconIndex];
    const texture = TextureManager.getTexture(iconPath);
    this.texture = texture;
  }
  remove() {
    this.parent.removeChild(this);
    this.destroy();
  }
}